var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrsvaretBorder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "theChar",
    "data-name": "forsvaret",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 156.91 71.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "a9e720c6-d06c-4b12-92d0-279b0cfcb37b",
    "data-name": "border",
    d: "M20.76,12.13S26.1,9.43,26.7,9,18.86.59,19,.29s19.15,1.1,21.58,2.39S52.81-.41,54.43.39,56,5.21,56,5.21,70.08,10.63,72.9,12,82.74,8.22,84.75,9s3.41,4.22,2.88,4.87,4.75,1.15,5,2.16-.8,5.62-.8,5.62l64.88,40s0,6-1.21,7.65-8.44,2.4-12.65,0-7.64.2-9.85,0S106.84,55.63,103,53.42s-27.52,13.86-30.13,13S17.52,33.33,18.26,33.33s-3.21-7.43-4-10S.79,10.23.79,10.23Z",
    style: {
      fill: "none",
      stroke: "#1d1d1b",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrsvaretBorder);
export default __webpack_public_path__ + "static/media/försvaret-border.9ea632c0.svg";
export { ForwardRef as ReactComponent };